import configHelpers from './config';

const { getCommonConfig } = configHelpers;

// base URLs that the shell embeds or calls but that are not identity-sdk child apps
const NON_CHILD_BASE_URL_KEYS = [
  'baseDataStudioUrl',
  'baseSupersetUrl',
  'baseTrackerUrl',
];

let baseUrlOrigins: Set<string> | undefined;

// commonConfig is fixed per deployment, so the child origins are read once
const getBaseUrlOrigins = () => {
  if (baseUrlOrigins) return baseUrlOrigins;
  const origins = new Set<string>();
  Object.entries(getCommonConfig() || {}).forEach(([key, value]) => {
    if (!/^base\w*Url$/.test(key) || NON_CHILD_BASE_URL_KEYS.includes(key))
      return;
    if (typeof value !== 'string') return;
    try {
      origins.add(new URL(value).origin);
    } catch {}
  });
  baseUrlOrigins = origins;
  return origins;
};

const isBaseUrlOrigin = (url: string) => {
  try {
    return getBaseUrlOrigins().has(new URL(url).origin);
  } catch {
    return false;
  }
};

/**
 * Returns the origin to reply to when `event` comes from one of the shell's own iframes
 * and `event.origin` is a configured child app origin, else null. The frame's current
 * origin can differ from its `src` when a child navigates it to another child app.
 */
const getTrustedChildOrigin = (event: MessageEvent): string | null => {
  if (!event.source) return null;
  const ownIframe = Array.from(document.querySelectorAll('iframe')).some(
    node => !!node.contentWindow && node.contentWindow === event.source
  );
  if (!ownIframe || !getBaseUrlOrigins().has(event.origin)) return null;
  return event.origin;
};

export default {
  getBaseUrlOrigins,
  isBaseUrlOrigin,
  getTrustedChildOrigin,
};
